import { AICousticsEnhancement_QualityTier } from '@polyai/schemas';
import {
  DEFAULT_VOICE_CHANNEL_AUDIO_ENHANCEMENT_ENABLED,
  DEFAULT_VOICE_CHANNEL_BARGE_IN_ALLOWED_FIRST_TURN,
  DEFAULT_VOICE_CHANNEL_BARGE_IN_ENABLED,
  DEFAULT_VOICE_CHANNEL_BARGE_IN_MAX_PER_CALL,
  DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_ENABLED,
  DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_INITIAL_INTERVAL_SECONDS,
  DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_INTERVAL_SECONDS,
  DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_MESSAGES,
  DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_RANDOMIZE,
  DEFAULT_VOICE_CHANNEL_SPEECH_END_WINDOW_SECONDS,
  DEFAULT_VOICE_CHANNEL_TEMPERATURE,
} from '@polyai/stream/constants/defaults';
import type {
  AudioEnhancement,
  BargeInConfig,
  FillerUtterances,
  VADConfig,
} from '@polyai/stream/protobuf/channels';

import { greetingReferencesAdapter } from '../agent-settings/adapters';
import { DEFAULT_AGENT_SETTINGS_LANGUAGE_CODE } from '../agent-settings/constants';
import { DEFAULT_AZURE_CONFIG } from '../content-filter-settings';
import type { ChannelConfig } from './types';

export const CHANNELS_SLICE_NAME = 'channels';

export const createDefaultVadConfig = (): VADConfig => ({
  speechEndWindowSeconds: DEFAULT_VOICE_CHANNEL_SPEECH_END_WINDOW_SECONDS,
});

export const createDefaultBargeInConfig = (): BargeInConfig => ({
  enabled: DEFAULT_VOICE_CHANNEL_BARGE_IN_ENABLED,
  allowedFirstTurn: DEFAULT_VOICE_CHANNEL_BARGE_IN_ALLOWED_FIRST_TURN,
  maxPerCall: DEFAULT_VOICE_CHANNEL_BARGE_IN_MAX_PER_CALL,
});

export const createDefaultAudioEnhancement = (): AudioEnhancement => ({
  provider: {
    $case: 'aiCoustics',
    value: {
      enabled: DEFAULT_VOICE_CHANNEL_AUDIO_ENHANCEMENT_ENABLED,
      modelQualityTier:
        AICousticsEnhancement_QualityTier.QUALITY_TIER_UNSPECIFIED,
      noiseReduction: 0,
      voiceGain: 0,
      noiseGate: false,
    },
  },
});

export const createDefaultSilenceFillerUtterances = (): FillerUtterances => ({
  enabled: DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_ENABLED,
  utterances: DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_MESSAGES.map(message => ({
    message,
  })),
  randomize: DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_RANDOMIZE,
  initialIntervalSeconds:
    DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_INITIAL_INTERVAL_SECONDS,
  intervalSeconds: DEFAULT_VOICE_CHANNEL_SILENCE_FILLER_INTERVAL_SECONDS,
});

export const createDefaultChannelConfig = (): ChannelConfig => ({
  llmSettings: {
    modelId: '',
    temperature: DEFAULT_VOICE_CHANNEL_TEMPERATURE,
    updatedAt: '',
    updatedBy: '',
  },
  stylePrompt: {
    prompt: '',
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
  },
  greeting: {
    welcomeMessage: '',
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
    references: greetingReferencesAdapter.createInitialState(),
    languageCode: DEFAULT_AGENT_SETTINGS_LANGUAGE_CODE,
  },
  safetyFilters: {
    type: 'azure',
    azureConfig: DEFAULT_AZURE_CONFIG,
    disabled: true,
    updatedAt: '',
    updatedBy: '',
  },
});
